import { Box } from '@mui/material';
import { forwardRef } from 'react';

const BoxWrapper = forwardRef((props, ref) => <Box {...props} ref={ref} />) as typeof Box;

export default BoxWrapper;
